import React, { FC, memo, useEffect } from 'react';
import { useBexApi } from '@shared-ui/bex-api-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import useLocale from '../../hooks/useLocale';
import useNavigationParams from '../../hooks/useNavigationParams';
import useGraphqlErrors from '../../hooks/useGraphqlErrors';
import PageHeaderMobile from './mobile/page-header-mobile';
import PageHeaderDesktop from './desktop/page-header-desktop';
import {
  DocumentationHeaderFragment,
  HeaderLinkFragment,
  UiLinkTarget,
  useHeaderQuery,
} from '../../graphql/__generated__/types';

const PageHeader: FC = () => {
  const { context } = useBexApi();
  const { hubId } = useNavigationParams();
  const { setHasError } = useGraphqlErrors();
  const { formatContent } = useLocale();

  const { data, error, loading } = useHeaderQuery({ variables: { context, hubId } });

  useEffect(() => {
    if (error) setHasError(true);
  }, [error]);

  if (!data || loading) {
    return null;
  }

  const HomeTab: HeaderLinkFragment = {
    __typename: 'EGDSStandardLink',
    text: formatContent('devhub.home.name', 'Home'),
    action: {
      __typename: 'UILinkAction',
      target: UiLinkTarget.INTERNAL,
      resource: {
        __typename: 'HttpURI',
        value: `https://developers.expediagroup.com/${hubId}`,
      },
    },
  };

  const { header } = data.documentation;

  const headerData: DocumentationHeaderFragment = {
    ...header,
    primaryNavigation: header.primaryNavigation ? [HomeTab, ...header.primaryNavigation] : [],
    secondaryNavigation: header.secondaryNavigation ? [...header.secondaryNavigation] : [],
  };

  return (
    <Viewport>
      <ViewSmall>
        <PageHeaderMobile headerData={headerData} />
      </ViewSmall>
      <ViewLarge>
        <PageHeaderDesktop headerData={headerData} />
      </ViewLarge>
    </Viewport>
  );
};

export default memo(PageHeader);
